import React, {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../ConfirmDialog";
import messages from "../../utils/messages";
import styles from "./ShipmentDetail.module.scss";
import { useDeleteProNumberMutation } from "../../services/authService";

const DeleteProValue = ({ type, id, onDelete, removeNewRow }) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [deleteProNumber, { isSuccess, error, reset }] =  useDeleteProNumberMutation();
    
    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        if(id) {
            deleteProNumber(id);
        } else {
            removeNewRow();
        }
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteProValue}`, {variant: 'success'});
            reset();
            onDelete();
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
    }, [isSuccess, error]);

    useEffect(() => {
      handleMessages();
    }, []);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon}`}
            />
            <ConfirmDialog
                title={`Delete Pro Value`}
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteProValue}
            </ConfirmDialog>
        </>
    )
}

export default DeleteProValue;
